import en from '../../profileContent.en';

const footer = {
    ...en.footer,
    phoneLabel: 'Tel.',
    emailLabel: 'Correo'
  };

export default footer;
